export const getTeamMembersUrl = () => '/business/team_members';

export const getTeamMemberUrl = (id: string) => `/business/team_members/${id}`;
